import { useEffect, useState } from "react";
import { debounce } from "../private/helpers";
export var useInnerHeight = () => {
  var [innerHeight, setInnerHeight] = useState("unset");
  useEffect(() => {
    var updateInnerHeight = () => {
      setInnerHeight(window.innerHeight + "px");
    };
    updateInnerHeight();
    var [debounceFunc, cancel] = debounce(updateInnerHeight);
    window.addEventListener("resize", debounceFunc);
    return () => {
      window.removeEventListener("resize", debounceFunc);
      cancel();
    };
  }, []);
  return innerHeight;
};